import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

import { getTimezoneNumber } from './timezone.ts';

dayjs.extend(utc);
dayjs.extend(timezone);

export const dayjsCustom = (date?: dayjs.ConfigType, tz?: number) =>
  dayjs(date).utcOffset(tz ?? getTimezoneNumber());

export const transformDateFilter = (date?: dayjs.ConfigType) => {
  const dateFrom = dayjs(date).startOf('day').utcOffset(getTimezoneNumber(), true).toISOString();
  const dateTo = dayjs(date).endOf('day').utcOffset(getTimezoneNumber(), true).toISOString();

  return { dateFrom, dateTo };
};
